(function (XHR) {
  "use strict";

  const originalOpen = XHR.prototype.open;
  const originalSend = XHR.prototype.send;

  XHR.prototype.open = function (method, url, async, user, pass) {
    this._url = url;
    this._responseHandled = false;
    this.calledOnce = false;
    originalOpen.call(this, method, url, async, user, pass);
  };

  XHR.prototype.send = function (data) {
    const url = this._url;

    if (String(url).toLowerCase() === "https://rbzizsivxfkend3njx686e6n.fast.sparq.ai/v2") {
      let body;
      try {
        body = JSON.parse(data);
      } catch (err) {
        console.error("Error parsing XHR data as JSON:", err);
        return originalSend.call(this, data);
      }

      // Robust URL parsing
      const { pathname, href } = new URL(window.location.href);
      const lowerPath = pathname.toLowerCase();

      // Extract /collections/<handle>
      const colMatch = lowerPath.match(/^\/collections\/([^/?#]+)/);
      const collectionHandle = colMatch ? decodeURIComponent(colMatch[1]) : null;

      // Page type flags (be precise!)
      const isSearchPage = lowerPath.startsWith("/search");
      const isTopAllPage = lowerPath === "/all"; // rarely used in Shopify, but kept
      const isAllProductsCollection = collectionHandle === "all"; // ONLY /collections/all

      // Safety guards
      if (!Array.isArray(body.sort)) body.sort = [];
      if (!Array.isArray(body.textFacets)) body.textFacets = [];

      // --- passthrough collection id redirect
      if (body.collection === "PVY7KSMSCPA19F1R9AQI85LW") {
        data = JSON.stringify(body);
        return originalSend.call(this, data);
      }

      // --- dropdown case (no facets)
      if (body.textFacets.length === 0) {
        body.filter = `priorityScore >= 0 AND publishedTimestamp < ${Date.now()} AND publishedTimestamp > 0 AND collectionHandles = "instant-search-sort-order"`;
        body.sort.push("sortOrderFor_instant_search_sort_order");
        data = JSON.stringify(body);
        return originalSend.call(this, data);
      }

      // --- search page (NO collection in URL and not home)
      if ((collectionHandle === null || collectionHandle === undefined) && pathname !== "/") {
        body.filter += " AND tags='Parent'";
        if (body.sort.length === 0) body.sort.push("price");
        data = JSON.stringify(body);
        return originalSend.call(this, data);
      }

      // --- home page
      if (pathname === "/") {
        body.filter += ` AND collectionHandles = "products" AND tags='Parent'`;
        body.sort.push("sortOrderFor_products");
        data = JSON.stringify(body);
        return originalSend.call(this, data);
      }

      // --- search or ALL PRODUCTS pages only
      // IMPORTANT: this will NOT catch /collections/allpro
      if (isSearchPage || isTopAllPage || isAllProductsCollection) {
        body.filter += " AND tags='Parent'";
        data = JSON.stringify(body);
        return originalSend.call(this, data);
      }

      // --- collection pages (including /collections/allpro, summer-tees, etc.)
      if (!isSearchPage && !isTopAllPage && !isAllProductsCollection && collectionHandle && body.textFacets.length > 0) {
        const collectionHandleFormatted = `sortOrderFor_${collectionHandle.replaceAll("-", "_")}`;
        if (!body.sort.includes(collectionHandleFormatted)) {
          body.sort.push(collectionHandleFormatted);
        }
        body.filter += " AND tags='Parent'";
        data = JSON.stringify(body);
        return originalSend.call(this, data);
      }
    }

    this.addEventListener("load", () => {
      if (!this._responseHandled && !this.calledOnce) {
        try { filterColorSwatch && filterColorSwatch(); } catch (e) {}
        this._responseHandled = true;
        this.calledOnce = true;
      }
    });

    originalSend?.call(this, data);
  };
})(XMLHttpRequest);

// Ensure the window.sq object exists
window.sq = window.sq || {};

//function for changing the display label of price filters
window.sq.discount = function (filters) {
  const subCategory = filters.find(
    (x) => x.stFieldName.toLowerCase() === "system_producttype"
  );

  if (subCategory) {
    subCategory?.items?.forEach((item) => {
      if (!item.originalDisplayLabel) {
        // Store the original label only once
        item.originalDisplayLabel = item.displayLabel;
      }
      // Append "s" only if it does not already end with "s"
      if (!item.displayLabel.endsWith("s")) {
        item.displayLabel += "s";
      }
    });
  }

  // Handle price range display labels
  const discountFilter = filters.find(
    (x) => x.stFieldName.toLowerCase() === "price"
  );

  if (discountFilter) {
    discountFilter.items[0].displayLabel = "Less than $10 ";
    discountFilter.items[1].displayLabel = "$10 to $20";
    discountFilter.items[2].displayLabel = "$20 to $40";
    discountFilter.items[3].displayLabel = "$40 to $60";
    discountFilter.items[4].displayLabel = "$60 to $80";
    discountFilter.items[5].displayLabel = "more than $80";
  }

  // Add 'See More' after a slight delay
  setTimeout(() => {
    addSeeMore();
  }, 500);

  return filters;
};


document.addEventListener("DOMContentLoaded", async function () {
  // Fetch and cache the JSON data once the DOM is fully loaded
  async function fetchColorGroupsJson() {
    try {
      const colorGroupsElement = document.getElementById("color-groups-json");
      if (colorGroupsElement) {
        const colorGroupsJsonStr = colorGroupsElement.textContent;
        window.sq.colorGroupsJsonData = await JSON.parse(colorGroupsJsonStr);

        // Create a lookup table for faster access
        window.sq.colorGroupsLookup = {};
        Object.entries(window.sq.colorGroupsJsonData).forEach(
          ([key, value]) => {
            const normalizedKey = key
              .toLowerCase()
              .replace(/\s+|\/+/g, "-")
              .replace(/-+/g, "-");
            window.sq.colorGroupsLookup[normalizedKey] = value;
          }
        );
      } else {
        window.sq.colorGroupsJsonData = {};
        window.sq.colorGroupsLookup = {};
      }
    } catch (e) {
      window.sq.colorGroupsJsonData = {};
      window.sq.colorGroupsLookup = {};
    }
  }
  await fetchColorGroupsJson();
  // Rest of your initialization code...
  searchpage();
  fetchVendorImage();
});

// Show specific elements on page load
window.addEventListener("load", function () {
  const elementsToShow = [
    ".container.sq-app.sq-dropdown",
    ".sq-filter-main",
    ".sq-head.dropdown-view-all",
    ".sparq-container",
  ];

  elementsToShow.forEach((selector) => {
    const element = document.querySelector(selector);
    if (element) {
      element.style.visibility = "visible";
    }
  });

  const sampleItem = { vendor: "vendor-json" };
  window.sq.fetchImage(sampleItem);
});

// Modal functions for filters
function toggleFilter() {
  const filterMain = document.querySelector(".sq-filter-main");
  filterMain?.classList.toggle("opening");
}

function removeClass() {
  const filterMain = document.querySelector(".sq-filter-main");
  filterMain?.classList.remove("opening");
}

// Function for adding the toggle button on color swatches
function toggleSwatch(ele) {
  const swatchElem = ele.closest(".color-swatch-toggle");
  if (swatchElem) {
    const currentStatus = swatchElem.getAttribute("data-swatch-open");
    const newStatus = currentStatus === "close" ? "open" : "close";
    swatchElem.setAttribute("data-swatch-open", newStatus);
    ele.textContent = newStatus === "open" ? "-" : "+";
  }
}

function toggleDefaultSwatch(ele) {
  const parentEle = ele.closest(".product-swatches");
  if (parentEle) {
    const currentStatus = parentEle.getAttribute("data-swatch-open");
    const newStatus = currentStatus === "close" ? "open" : "close";
    parentEle.setAttribute("data-swatch-open", newStatus);
  }
}

window.sq.onData = (searchResults) => {
  setTimeout(() => {
    addSeeMore();
  }, 500);
  return searchResults.results;
};

// Function for showing "See More" and "See Less" on side filters
function addSeeMore() {
  document.querySelectorAll(".sq-filter-group .sq-accordion").forEach((e) => {
    const accordionBody = e.querySelector(".sq-accordion-body");
    if (accordionBody && accordionBody.offsetHeight >= 303) {
      if (!e.querySelector(".see-more")) {
        const seeMoreText = document.createElement("div");
        seeMoreText.classList.add("see-more");
        seeMoreText.onclick = () => {
          accordionBody.scrollTop = 0;
          e.classList.toggle("expanded");
        };
        e.appendChild(seeMoreText);
      }
    }
  });
}

window.sq.initSearch = (store) => {
  store.search();
};

// Function for toggle button on swatches
window.sq.addBtn = function (item) {
  if (item.option_auto_color && item.option_auto_color.length > 1) {
    item.colorSwatch = true;
    item.colorSwatchOpen = false;
  }
  return item;
};

window.sq.toggleColorSwatch = function (item) {
  item.colorSwatchOpen = !item.colorSwatchOpen;
  return item;
};

// Function for fetching the color swatches
function fetchColorSwatch() {
  try {
    const lookup = window.sq.colorGroupsLookup;
    const swatchItems = document.querySelectorAll(".sq-pallete-item");

    // Initialize an empty array to store the color data
    const colorDataArray = [];

    // Loop through each swatch item
    swatchItems.forEach((swatchItem) => {
      const titleElement = swatchItem.querySelector(".sq-pallete-color");
      if (titleElement) {
        let title = titleElement.getAttribute("title").toLowerCase();
        title = title.replace(/\s+|\/+/g, "-").replace(/-+/g, "-");

        const matchingEntry = lookup[title];

        if (matchingEntry) {
          const { hex, group } = matchingEntry;

          // Construct the color data object
          const colorData = {
            type: 1,
            title: group,
            colors: [title.charAt(0).toUpperCase() + title.slice(1)], // Capitalize the first letter of the color
            colorCode: `#${hex}`
          };
          // Push the color data into the array
          colorDataArray.push(colorData);
        }
      }
    });

    // Return the array of color data objects
    return colorDataArray;
  } catch (e) {
    console.log('Error in fetching colors', e);
    // Handle errors if necessary
    return []; // Return an empty array in case of an error
  }
}

// Function for fetching the vendor image
function fetchVendorImage() {
  try {
    window.sq.vendor = JSON.parse(
      document.getElementById("vendor-json")?.textContent
    );

    document.querySelectorAll(".sparq-vendor").forEach((sparqVendorDiv) => {
      const shopifyVendor = sparqVendorDiv.getAttribute("data-shopify-vendor");
      if (window.sq.vendor[shopifyVendor]) {
        const imageUrl = window.sq.vendor[shopifyVendor];

        const existingImage = sparqVendorDiv.nextElementSibling;
        if (existingImage && existingImage.classList.contains("sq-image")) {
          return;
        }

        const imgHtml = `
          <div class="sq-image">
            <img rel="preload" src="${imageUrl}" class="sq-logo"/>
          </div>
        `;
        sparqVendorDiv.insertAdjacentHTML("afterend", imgHtml);
      }
    });
  } catch (e) {
    //console.log("Error fetching vendor images");
  }
}

window.sq.fetchImage = function (item,store) {
  try {
    if(window.location.href.includes('search')) {
      window.sq.fetchSearchImage(item,store)
    }
    const jsonData = window.sq.vendor;
    return jsonData[item.vendor] || null;
  } catch (e) {
    //console.log("Vendor not found in JSON data");
    return null;
  }
};

// Function for side filter (color swatch)
function filterColorSwatch() {
  const items = document.querySelectorAll(".sq-filter-item.sq-block");
  items.forEach((item) => {
    const filterValueElement = item.querySelector(
      ".sq-filter-value.sq-multi-select"
    );

    if (filterValueElement) {
      const classList = filterValueElement.classList;
      const colorClass = Array.from(classList).find(
        (c) => !["sq-filter-value", "sq-multi-select", "sq-active"].includes(c)
      );

      if (colorClass) {
        const newClass =
          "color-option-" +
          colorClass.toLowerCase().replace(/_/g, "-").replace(/-+/g, "-");
        if (!filterValueElement.querySelector(`.${newClass}`)) {
          const span = document.createElement("span");
          span.classList.add("ss-facet-swatches", newClass);
          filterValueElement.insertBefore(span, filterValueElement.firstChild);
        }
      }
    }
  });
}

function searchpage() {
  if (window.location.href.includes("search")) {
    const element = document.querySelector(
      ".padding-bottom--up-4.padding-top--up-1"
    );
    if (element) {
      element.style.display = "none";
    }
  }
}

window.sq.getHandle = function (item, filters) {
  const selectedColor = filters
    ?.find((filter) => filter.stFieldName === "sq_color")
    ?.items?.find((item) => item.selected)?.label;

  const variantArray = item?.original?.variants ?? item.variants;

  if (!selectedColor || !variantArray) {
    // console.warn("Missing selectedColor or variantArray:", { selectedColor, variantArray });
    return item;
  }

  function isSimilarColor(color1, color2) {
    function normalizeColor(color) {
      return color
        .toLowerCase()
        .trim()
        .replace(/-/g, " ") // Replace hyphens with spaces
        .replace(/gray/g, "grey"); // Standardize "gray" to "grey"
    }

    const normalizedColor1 = normalizeColor(color1);
    const normalizedColor2 = normalizeColor(color2);

    if (
      normalizedColor1.includes(normalizedColor2) ||
      normalizedColor2.includes(normalizedColor1)
    ) {
      return true;
    }

    const words1 = normalizedColor1.split(/\s+/);
    const words2 = normalizedColor2.split(/\s+/);
    const commonWords = words1.filter((word) => words2.includes(word));

    return commonWords.length > 0;
  }

  const normalizedSelectedColor = selectedColor.toLowerCase();
  let matchingVariant = variantArray.find((x) => {
    const option1 = x.option1.toLowerCase();
    const variantColors = option1.split(/[\/,&]+/).map((color) => color.trim());

    return variantColors.some((variantColor) =>
      isSimilarColor(variantColor, normalizedSelectedColor)
    );
  });

  if (!matchingVariant && window.sq.colorGroupsJsonData) {
    const selectedGroup = Object.keys(window.sq.colorGroupsJsonData || {}).find(
      (key) => normalizedSelectedColor.includes(key.toLowerCase())
    );

    if (selectedGroup) {
      const groupData = window.sq.colorGroupsJsonData[selectedGroup];
      matchingVariant = variantArray.find((x) => {
        const option1 = x.option1.toLowerCase();
        const variantColors = option1
          .split(/[\/,&]+/)
          .map((color) => color.trim());

        return variantColors.some((variantColor) => {
          const group = window.sq.colorGroupsJsonData[variantColor];
          return (
            group && groupData.group.toLowerCase() === group.group.toLowerCase()
          );
        });
      });
    }
  }

  if (matchingVariant) {
    const selectedImage = item.images?.find(
      (x) => x?.id == matchingVariant.image_id
    );

    item.image.src =
      selectedImage?.src ?? item.images?.[0]?.src ?? item.image.src ?? "";
  } else {
    console.warn(
      "No matching variant found for selected color:",
      selectedColor
    );
  }

  return item;
};

window.sq.fetchSearchImage = function (item, store) {
  const selectedColor = store?.filters
    .find((filter) => filter.stFieldName === "sq_color")
    ?.items?.find((item) => item.selected)?.label;
  // Check if the query contains "select" to determine whether to call getHandle
  if (selectedColor) {
    // Call getHandle if the query contains "select"
    return window.sq.getHandle(item, store?.filters);
  }

  // Get the color or keyword from the query for regular color matching
  const queryKeyword = store?.query?.toLowerCase() ?? "";
  const queryWords = queryKeyword.split(/\s+/);
  const primaryQueryColor = queryWords[0]; // Use the first word as the primary color for matching

  const variantArray = item?.original?.variants ?? item.variants;

  // Try to find a variant that matches the color keyword in the query
  let matchingVariant = variantArray.find((x) => {
    const option1 = x.option1.toLowerCase();
    const variantColors = option1.split(/[\/,&]+/).map((color) => color.trim());

    // Check if any word in the variant color matches the primary query color
    return variantColors.some((variantColor) => {
      const variantColorWords = variantColor.split(/\s+/);
      return variantColorWords.some((word) => word === primaryQueryColor);
    });
  });

  // If no exact match, fall back to color group matching
  if (!matchingVariant && window.sq.colorGroupsJsonData) {
    const queryGroup = Object.keys(window.sq.colorGroupsJsonData).find(
      (key) => primaryQueryColor === key.toLowerCase()
    );

    if (queryGroup) {
      const groupData = window.sq.colorGroupsJsonData[queryGroup];
      const groupVariant = variantArray.find((x) => {
        const option1 = x.option1.toLowerCase();
        const variantColors = option1
          .split(/[\/,&]+/)
          .map((color) => color.trim());

        return variantColors.some((variantColor) => {
          return (
            groupData.group.toLowerCase() ==
            window.sq.colorGroupsJsonData[variantColor]?.group.toLowerCase()
          );
        });
      });

      matchingVariant = groupVariant || matchingVariant;
    }
  }
  
  // If a matching variant is found, set the corresponding image
  if (matchingVariant) {
    let selectedImage = item.images?.filter(
      (x) => x?.id == matchingVariant.image_id
    );
    item.image.src =
      selectedImage[0]?.src ?? item.images[1]?.src ?? item.image.src ?? "";
  }

  return item;
};

window.sq.colorSwatch = function (item, store) {
  try {
    // Cache the lookup object with safety check
    if (!window.sq._cachedLookup) {
      if (window.sq.colorGroupsLookup) {
        window.sq._cachedLookup = window.sq.colorGroupsLookup;
      } else {
        console.log('Error: window.sq.colorGroupsLookup is not available');
        return item;
      }
    }
    
    const lookup = window.sq._cachedLookup;
    
    // Initialize an array to collect all the color data
    const colorDataArray = [];

    // Check if item.option_auto_color exists and is an array
    if (Array.isArray(item.option_auto_color) && item.option_auto_color.length > 0) {
      // Loop through each color in the option_auto_color array
      item.option_auto_color.forEach((color) => {
        // Normalize the color (convert to lowercase and replace spaces/slashes)
        let title = color.toLowerCase().replace(/\s+|\/+/g, "-").replace(/-+/g, "-");

        const matchingEntry = lookup[title];

        if (matchingEntry) {
          const { hex, group } = matchingEntry;

          // Construct the color data object and push to the array
          const colorData = {
            type: 1,
            title: group,
            colors: [color.charAt(0).toUpperCase() + color.slice(1)], // Capitalize the first letter of the color
            colorCode: `#${hex}`
          };
          colorDataArray.push(colorData);  // Accumulate the color data
        }
      });
    } else {
      // If no valid colors are found, push the hardcoded data
      console.log("No colors found in item.option_auto_color, pushing hardcoded data.");
    }

    if (store.config && store.config.colorGroups && store.config.colorGroups[0]) {
      
      // Initialize colors array if it doesn't exist
      if (!Array.isArray(store.config.colorGroups[0].colors)) {
        store.config.colorGroups[0].colors = [];
      }
      
      // Simply push new colors - no duplicate checking for performance
      store.config.colorGroups[0].colors.push(...colorDataArray);
      
    } else {
      console.log('Error: store.config.colorGroups[0] is not defined.');
    }

    return item;
  } catch (e) {
    console.log('Error in processing colors', e);
    return item;  // Return the item in case of an error to avoid breaking the flow
  }
}

// Optional: Call this ONCE after all items are processed to remove duplicates
window.sq.deduplicateColors = function(store) {
  if (store.config && store.config.colorGroups && store.config.colorGroups[0] && store.config.colorGroups[0].colors) {
    const uniqueColors = [];
    const seen = new Set();
    
    store.config.colorGroups[0].colors.forEach(color => {
      if (!seen.has(color.colorCode)) {
        seen.add(color.colorCode);
        uniqueColors.push(color);
      }
    });
    
    store.config.colorGroups[0].colors = uniqueColors;
  }
};
